module.exports = __webpack_public_path__ + "static/media/mic.846a4d49.svg";